//Module Keys
let locales = {};

//Merge Views
import unsubscribedContactsMain from '../../views/main/lan/es';
import createUnsubscribedContact from 'Modules/unsubscribedContacts/.components/createUnsubscribedContact/lan/es';
import deleteUnsubscribedContact from 'Modules/unsubscribedContacts/.components/deleteUnsubscribedContact/lan/es';


locales = { 
    ...locales, 
    ...unsubscribedContactsMain, 
    ...createUnsubscribedContact,
    ...deleteUnsubscribedContact,
};

export default locales;